import * as userRequest from "@/utils/userRequest";

interface QueryParams {
  startDate: string;
  endDate: string;
  timezone: string;
}

export default async function getPortfolioTotalProfit(
  token: string,
  onSuccess?: (data?: any) => any,
  handleError?: (err?: any) => any,
  queryParams?: QueryParams
) {
  try {
    const res = await userRequest.post(
      "portfolio/statistic/chart/total-profit",
      {
        startDate: queryParams?.startDate,
        endDate: queryParams?.endDate,
        timezone: queryParams?.timezone,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("🚀 ~ getPortfolioTotalProfit ~ res:", res);
    if (true || res) {
      onSuccess && onSuccess(res);
      return res;
    }
  } catch (err) {
    console.log("🚀 ~ getPortfolioTotalProfit ~ err:", err);
    handleError && handleError(err);
  }
}
